import React from 'react';
import { NumberInput, BooleanInput, useTranslate } from 'react-admin';
import { shouldFieldBeDisabled, getFieldHelperText } from '../../../utils/eventFormUtils';

/**
 * Event Fees Tab Component
 * Handles fee and commission settings
 */
export const EventFeesTab = ({ systemParams, permissions = {} }) => {
  const translate = useTranslate();

  if (!systemParams || !systemParams.variables) {
    return (
      <div style={{ padding: 20, color: 'red' }}>
        <h3>
          {translate(
            'form.system_params_error',
            'System Parameters could not be loaded, this is an error that needs to be reported to Gişe Kıbrıs. Please do so before creating/editing your event.',
          )}
        </h3>
      </div>
    );
  }

  return (
    <React.Fragment>
      <NumberInput
        onWheel={(event) => {
          event.target.blur();
        }}
        source="servicefee"
        min={0}
        fullWidth
        label={translate('form.service_fee', 'Event Service Fee (TL)')}
        helperText={translate('form.service_fee_hint', 'Service fee to cover extra operational cost.')}
        defaultValue={systemParams.variables.defaultServiceFee}
        disabled={shouldFieldBeDisabled('servicefee', permissions)}
      />

      <NumberInput
        onWheel={(event) => {
          event.target.blur();
        }}
        source="commissionFee"
        min={0}
        fullWidth
        label={translate('form.commission_fee', 'Event Commission Fee (%)')}
        defaultValue={systemParams.variables.defaultCommissionFee}
        disabled={shouldFieldBeDisabled('commissionFee', permissions)}
      />

      <BooleanInput
        source="isCommissionExtra"
        defaultValue={false}
        label={translate('form.is_commission_extra', 'Is commission extra (added to ticket prices)?')}
        helperText={translate('form.is_commission_extra_hint', 'Please note that the prices for the event will change if this is turned on.')}
      />
    </React.Fragment>
  );
};
